import { lastQuoteApi } from 'apiConnector/quote/lastquote';
import { tabRemoved } from 'epic/workspace/common/tabs/tabsEpics';
import { ofType } from 'redux-observable';
import type { SchedulerLike } from 'rxjs';
import { of, throwError } from 'rxjs';
import { catchError, filter, mergeMap, takeUntil, timeoutWith } from 'rxjs/operators';
import { commonQuoteAction } from 'state/forms/actions/quote';
import { statifiedPreviousQuoteLoadedThunk } from 'state/forms/thunks';
import type { EpicWithThunk } from 'state/state.common';

export function fetchStatifiedLastQuoteEpic(
  timeoutInMillis: number = 60000,
  appScheduler?: SchedulerLike,
): EpicWithThunk {
  return (action$, state$, { httpClient }) =>
    action$.pipe(
      ofType('PREVIOUS_QUOTE_LOAD_REQUESTED'),
      filter(action => action.workspace === 'static' || action.workspace === 'essential'),
      mergeMap(({ tabId, quoteId, workspace }) => {
        const tabRemoved$ = tabRemoved(action$, tabId, state$);
        const api = lastQuoteApi(httpClient);
        return api.getLastQuote(quoteId).pipe(
          mergeMap(quoteResult => of(statifiedPreviousQuoteLoadedThunk(workspace, tabId, quoteId, quoteResult))),
          timeoutWith(timeoutInMillis, throwError('Timeout'), appScheduler),
          catchError(_ => {
            return of(commonQuoteAction.previousQuoteLoadingFailed(workspace, tabId, quoteId));
          }),
          takeUntil(tabRemoved$),
        );
      }),
    );
}
